import { render, staticRenderFns } from "./DialogServiceAcces.vue?vue&type=template&id=7c84f20f"
import script from "./DialogServiceAcces.vue?vue&type=script&lang=js"
export * from "./DialogServiceAcces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports